import React from 'react';
import './DispatchBoard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import { faToolbox, faTruck } from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import EquipmentAssignmentCard from './EquipmentAssignmentCard';
import { DraggableResourceTypes } from './Dispatch';

export default class EquipmentJobAssignment extends React.Component {
    getStatusName = () => this.props.requiredEquipmentType?.assignment ? this.props.requiredEquipmentType?.assignment?.confirmationStatusName
        .replace(' ', '')
        .toLowerCase() : '';
    
    // support keyboard “click”
    handleKeyDown = (e, dropId, ids) => {
        if (e.key === 'Enter' || e.key === ' ') {
            this.props.onSlotSelect('equipment', ids, dropId);
        }
    };

    render() {
        const {
            job,
            jobIndex,
            day,
            requiredEquipmentType,
            dayAssignments,
            assignmentIndex,
            isDropZoneValid,
            dragging,
            onSlotSelect,
            pulsingSlotId,
        } = { ...this.props };

        const dropId = `equipment_${jobIndex}_${day.getDay()}_${assignmentIndex}`;
        const hasAssignment = !!requiredEquipmentType.assignment;
        const canDrop =
            isDropZoneValid(
                DraggableResourceTypes.Equipment,
                requiredEquipmentType.description
            ) && !hasAssignment;
        
        const ids = requiredEquipmentType.requiredEquipment.map(g => g.id);

        return (
            <div
                key={requiredEquipmentType.assignmentId}
                className="jobAssignment"
            >
                <Droppable
                    key={dropId}
                    droppableId={dropId}
                    isDropDisabled={!canDrop}
                    style={{ transform: 'none' }}
                >
                    {(provided, snapshot) => (
                        <div
                            className="assignment-placeholder-row"
                            style={{ height: '50px !important' }}
                        >
                            <div
                                className={cls('jobAssignmentDropTarget', this.getStatusName(), {
                                    dragging: snapshot.isDraggingOver,
                                    show: !hasAssignment || snapshot.isDraggingOver,
                                    invalidDropZone: !canDrop && dragging,
                                    occupied: hasAssignment,
                                    pulse: !hasAssignment && dropId === pulsingSlotId
                                })}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                role={!hasAssignment ? 'button' : undefined}
                                tabIndex={!hasAssignment ? 0 : undefined}
                                onClick={() => {
                                    if (!hasAssignment) onSlotSelect('equipment', ids, dropId);
                                }}
                                onKeyDown={(e) =>
                                    this.handleKeyDown(e, dropId, ids)
                                }
                            >
                                {hasAssignment ? (
                                    <EquipmentAssignmentCard
                                        removable
                                        compact
                                        innerRef={provided.innerRef}
                                        provided={provided}
                                        job={job}
                                        jobIndex={jobIndex}
                                        day={day}
                                        dayAssignments={dayAssignments}
                                        assignmentIndex={assignmentIndex}
                                        assignmentRequirements={
                                            requiredEquipmentType
                                        }
                                        requiredEquipment={
                                            requiredEquipmentType.assignment
                                                ?? null
                                        }
                                        onEquipmentAssignmentChange={
                                            this.props
                                                .onEquipmentAssignmentChange
                                        }
                                        onRemoveAssignment={
                                            this.props.onRemoveAssignment
                                        }
                                    />
                                ) : (
                                    <div className="dropPlaceholderWrapper">
                                        <label className="dropPlaceholder">
                                            <span
                                                style={{
                                                    fontSize: '9px',
                                                    fontWeight: 600,
                                                    textTransform: 'uppercase',
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={requiredEquipmentType.isVehicle ? faTruck : faToolbox}
                                                    className="mr-1"
                                                />
                                            </span>
                                            
                                            {requiredEquipmentType.isRental ? (
                                                <>
                                                    {requiredEquipmentType.isGeneric ? (
                                                        <>
                                                            {requiredEquipmentType.description}
                                                            {' '}

                                                        
                                                            {requiredEquipmentType.rentalDropoffQuantity > 0 && `(Dropoff x ${requiredEquipmentType.rentalDropoffQuantity}) `}
                                                            {requiredEquipmentType.rentalPickupQuantity > 0 && `(Pickup x ${requiredEquipmentType.rentalPickupQuantity}) `}
                                                            
                                                        </>
                                                    ) : (
                                                        <>
                                                            {requiredEquipmentType.description}
                                                            {' '}

                                                            {requiredEquipmentType.isRentalPickup ? '(Pickup)' : '(Dropoff)'}
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {requiredEquipmentType.quantity >= 1 && requiredEquipmentType.isGeneric
                                                        ? `${requiredEquipmentType.description} x ${requiredEquipmentType.quantity}`
                                                        : requiredEquipmentType.description
                                                    }
                                                </>
                                            )}
                                        </label>
                                    </div>
                                )}

                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
